import { render, staticRenderFns } from "./jiating.vue?vue&type=template&id=0c33cd73&scoped=true&"
import script from "./jiating.vue?vue&type=script&lang=js&"
export * from "./jiating.vue?vue&type=script&lang=js&"
import style0 from "./jiating.vue?vue&type=style&index=0&id=0c33cd73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c33cd73",
  null
  
)

export default component.exports